export default function HourglassIcon({}) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 4H18" stroke="white" />
        <path d="M6 20H18" stroke="white" />
        <path
          d="M8 4V7.52786C8 9.04295 8.85601 10.428 10.2111 11.1056L12 12L13.7889 11.1056C15.144 10.428 16 9.04295 16 7.52786V4"
          stroke="white"
        />
        <path
          d="M8 20V16.4721C8 14.957 8.85601 13.572 10.2111 12.8944L12 12L13.7889 12.8944C15.144 13.572 16 14.957 16 16.4721V20"
          stroke="white"
        />
        <path
          d="M14.4453 19.5C14.2717 18.691 13.6867 18.0195 12.8906 17.7471L12.6963 17.6895L12.6064 17.667C12.2581 17.5799 11.8958 17.5695 11.5439 17.6348L11.3936 17.667L11.3037 17.6895C10.4094 17.9132 9.74211 18.6264 9.55469 19.5H14.4453Z"
          fill="white"
          stroke="white"
        />
      </svg>
    </>
  );
}
